<script>
</script>

<div class="indicator is-flex is-justify-content-center">
  <i class="far fa-spinner-third fa-4x fa-spin" />
</div>

<style>
</style>
